import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport, withXhr } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withPreloading } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { AgChartsCommunityModule } from 'ag-charts-community';
import { AllEnterpriseModule, IntegratedChartsModule, LicenseManager, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-enterprise';
import { PlexEnvironment } from 'environments/environment';
import { msalProviders } from "./app-msal.config";
import { routes } from "./app.routes";
import { ErrorsHandler } from "./errors/errors-handler";
import { SelectivePreloadingStrategy } from "./shared/services/strategy/selective-preload-strategy";

export const appConfig: ApplicationConfig = {
  providers: [
    ...msalProviders,
    provideHttpClient(withXhr(), withInterceptorsFromDi(), withJsonpSupport()),
    provideAnimations(), //deprecated, but needed for kendo components until they upgrade
    provideRouter(routes, withPreloading(SelectivePreloadingStrategy)),
    provideAppInitializer(() => {
      return AppInitializerFactory(
        inject(PlexEnvironment),
        inject(MsalService)
      )();
    }),
    provideZoneChangeDetection(),
    { provide: ErrorHandler, useClass: ErrorsHandler },
  ]
}

export function AppInitializerFactory(plex: PlexEnvironment, msalService: MsalService) {
  return async () => {
    plex.populate();
    LicenseManager.setLicenseKey(plex.agGridLicense);
    ModuleRegistry.registerModules([AllEnterpriseModule, IntegratedChartsModule.with(AgChartsCommunityModule)]);
    provideGlobalGridOptions({ theme: "legacy" });
    await msalService.instance.initialize();
  };
}
